export default {
    home: {
        headingText: 'Salut world!',
        bodyText: 'Ceci est un POC for Vue 3 component library',
    },
};
